import { Endpoint } from '../endpoint';
import { FilterResponse, FilterMappingResponse } from '@business/entities/filter';

export function fetchFilters() {
  return Endpoint.get<FilterResponse[]>(`@gc/filters`);
}

export function createFilter(filter: Partial<FilterResponse>) {
  return Endpoint.post<FilterResponse>(`@gc/filters/create`, { data: { ...filter } });
}

export function updateFilter(id: string, filter: Partial<FilterResponse>) {
  return Endpoint.post<FilterResponse>(`@gc/filters/${id}`, { data: filter });
}

export function deleteFilter(filterId: string) {
  return Endpoint.delete<void>(`@gc/filters/${filterId}`);
}

export function getMapping(type: 'organization' | 'contact') {
  return Endpoint.get<FilterMappingResponse[]>(`@gc/filters/mapping/${type}`);
}
